import React, { Component } from 'react'
import PropTypes from 'prop-types'
// import { Link, graphql, useStaticQuery } from 'gatsby'
import styled, { css } from 'styled-components'
import { Grid, Col, Row } from 'react-styled-flexboxgrid'
import ReactDropdown from 'react-dropdown'
import 'react-dropdown/style.css'
import { colors, device } from '../../styles/config'
import FormDropdownSvg from '../../images/form-dropdown.svg'

const options = {
  capacity: [
    '50-100 (nur Okt - Apr)',
    '100 - 150',
    '150 - 200',
    '200 - 250',
    '250 - 300',
    '300 - 400',
    '400 - 500',
    '500 +',
  ],
  occasion: [
    { value: 'Hochzeit', label: 'Hochzeit' },
    { value: 'Sommerfest', label: 'Sommerfest' },
    { value: 'Geburtstag', label: 'Geburtstag' },
    { value: 'Weihnachtsfeier', label: 'Weihnachtsfeier' },
    { value: 'Firmenevent', label: 'Firmenevent' },
    // {
    //   type: 'group',
    //   name: '--------',
    //   items: [
    // { value: 'Privat', label: 'Privat' },
    // { value: 'Konzert', label: 'Konzert' },
    // { value: 'Öffentliches Event', label: 'Öffentliches Event' },
    // { value: 'Sonstiges', label: 'Sonstiges' },
    // ]
    // }
  ],
  budget: [
    '< 2.000 €',
    '2.000 € - 3.000 €',
    '3.000 € - 5.000 €',
    '> 5.000 €',
  ]
}

const Container = styled.div`
  width: 100%;
`

const StyledDropdown = styled(ReactDropdown)`
  .Dropdown-control,
  .Dropdown-menu {
    border: 1px solid ${ props => props.error ? 'red' : colors.primary };
    border-radius: 0;
    color: ${ colors.primary };
    padding: 0 0.8rem;
    line-height: 2.4;
  }

  .Dropdown-control {
    padding-right: 3.3rem;
  }

  .Dropdown-menu {
    /* revisit after handling long case */
    /* width: 500px; */
    padding: 0;
  }

  .Dropdown-option {
    padding: 0;
    color: ${ colors.primary };
    padding: 0 0.8rem;
  }

  .Dropdown-arrow {
    border: none;
    height: 100%;
    right: 0;
    top: 0;
    width: 40px;
    border-left: 1px solid ${ props => props.error ? 'red' : colors.primary };
    background-image: url(${ FormDropdownSvg });
    background-size: 13px 8px;
    background-repeat: no-repeat;
    background-position: center;
  }

  &.is-open .Dropdown-arrow {
    border: none;
    border-left: 1px solid ${ props => props.error ? 'red' : colors.primary };
  }
`

const Dropdown = ({ type, years, placeholder, onChange, value, name, error, className }) => {
  function handleChange (dropdownData) {
    onChange({
      target: {
        name: name,
        value: dropdownData.value
      }
    })
  }

  return (
    <Container className={className}>
      <StyledDropdown
        placeholder={placeholder}
        options={years || options[type]}
        onChange={handleChange}
        value={value}
        error={error}
      />
    </Container>
  )
}

export default Dropdown
